/**
 * Метки перехода на главную (МР-19): канал и кампания из utm_source / utm_campaign, партнёр из ?ref, страна из ?country.
 * Запоминаются на время вкладки — человек может уйти по ссылкам внутри сайта и вернуться к форме.
 * Заявка на доступ и регистрация отправляют их вместе с данными формы.
 */
export interface Attribution {
  channel?: string;
  campaign?: string;
  partner?: string;
  countryCode?: string;
}

const KEY = 'epc:attribution';

function clean(v: string | null, max: number): string | undefined {
  const t = (v ?? '').trim().slice(0, max);
  return t || undefined;
}

/** Прочитать метки из адреса и сохранить; вызывается при открытии главной и формы заявки */
export function captureAttribution(): Attribution {
  let fresh: Attribution = {};
  try {
    const q = new URLSearchParams(window.location.search);
    const country = clean(q.get('country'), 2)?.toUpperCase();
    fresh = {
      channel: clean(q.get('utm_source'), 60),
      campaign: clean(q.get('utm_campaign'), 80),
      partner: clean(q.get('ref'), 40)?.toLowerCase(),
      countryCode: country && /^[A-Z]{2}$/.test(country) ? country : undefined,
    };
  } catch {
    /* адрес недоступен — меток нет */
  }
  const saved = readAttribution();
  const merged: Attribution = { ...saved };
  for (const [k, v] of Object.entries(fresh)) if (v) merged[k as keyof Attribution] = v;
  try {
    if (Object.keys(merged).length) sessionStorage.setItem(KEY, JSON.stringify(merged));
  } catch {
    /* хранилище недоступно — метки живут до перезагрузки */
  }
  return merged;
}

export function readAttribution(): Attribution {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Attribution) : {};
  } catch {
    return {};
  }
}
